import { inject } from 'aurelia-framework';
import { HttpClient, json } from 'aurelia-fetch-client';

@inject(HttpClient)
export class StageService {
    constructor(http) {
        this.http = http;
        this.singular = 'stage';
        this.plural = 'stages';
        this.editor = PLATFORM.moduleName('pages/system-fields/stages/editor/index');
    }

    async filter(loadOptions) {
        const response = await this.http.fetch(`stages/filter/${loadOptions}`);
        return await response.json();
    }

    async create(stage) {
        await this.http.fetch('stages', { method: 'POST', body: json(stage) });
    }

    async update(stage) {
        await this.http.fetch(`stages/${stage.id}`, { method: 'PUT', body: json(stage) });
    }

    async delete(id) {
        await this.http.fetch(`stages/${id}`, { method: 'DELETE' });
    }

    async getById(id) {
        const response = await this.http.fetch(`stages/${id}`);
        return await response.json();
    }

    async filterTopThree(query) {
        if (query == null || query.length === 0) return [];
        const response = await this.http.fetch(`stages/top-three/${query}`);
        return await response.json();
    }
}